module.exports = __webpack_public_path__ + "img/swao.62dcaa73.png";